<template>
    <div id="ticket-component">
        <form id="formTicketQuoter" class="animated fadeIn formTicketQuoter">
            <div class="row">
                <input type="hidden" name="quoter_id" :value="quoter_id">
                <input type="hidden" name="renew" :value="renew">
                <div class="col-12 col-sm-12" v-if="this.renew===1">
                    <select name="client_id" id="client_id" class="required" data-select="on" data-name-input="Seleccione un cliente">
                        <option :value="0">Seleccione un cliente</option>
                        <option v-for="client in clients" :value="client.id">
                            {{ client.sku }} - <span v-if="client.tipo_per===1">{{ client.nombre }} {{ client.paterno }} {{ client.materno }}</span>  <span v-else>{{ client.nmComPerMoral }}</span>
                        </option>
                    </select>
                </div>
                <div class="col-12 col-sm-10">
                    <input type="text" name="price" class="al-inputs required scr-input" placeholder="Costo" id="price">
                </div>
                <div class="col-12 col-sm-2">
                    <input type="checkbox" name="is_financed" class="mt-4" placeholder="is_financed" id="is_financed" value="1"> Es Financiado
                </div>
                <div class="col-12 col-sm-4">
                    <date-picker inputName="payment_date" input-class="mx-input scr-input" v-model="payment_date" format="YYYY-MM-dd" placeholder="Fecha de Pago" lang="es"></date-picker>
                </div>
                <div class="col-12 col-sm-4">

                    <date-picker inputName="start_date" input-class="mx-input scr-input" v-model="start_date" format="YYYY-MM-dd" placeholder="Inicio de Vigencia" lang="es"></date-picker>
                </div>
                <div class="col-12 col-sm-4">

                    <date-picker inputName="end_date" input-class="mx-input scr-input" v-model="end_date" format="YYYY-MM-dd" placeholder="Fin de Vigencia" lang="es"></date-picker>
                </div>
                <div class="col-12 col-sm-12">
                    <div class="fotoUploader">
                        <span class="btn btn-file">
                            Documento <br> <i class="fas fa-upload"></i>
                            <input type="file" class="required" accept="image/*,.pdf" data-label="avatar"
                                   name="ticket_file" v-on:change="getLogo" placeholder="Documento">
                        </span>
                        <span class="label-file-papeleria alert alert-info logo"></span>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <p class="fotoUploader">
                        <strong>Formatos permitidos: .jpeg, .png, .jpg, .gif, .pdf, con un peso máximo de 500kb</strong>
                    </p>
                </div>
                <div class="col-12 col-sm-12">
                    <button id="dyn-button" type="button" class="btn btn-primary addNote" v-on:click="guardar()">
                        {{ tituloBtn }}
                    </button>
                </div>
            </div>
        </form>

        <div class="col-12 col-sm-12">
            <h2 class="cabeza">Ticket de la cotización</h2>
            <b-table responsive v-if="tickets[0]!==null" id="my-table" striped hover :fields="fields" :busy="isBusy"
                     :items="tickets" show-empty>
                <template #empty="scope">
                    <h4 class="emptyRow">
                        No hay datos para mostrar.
                    </h4>
                </template>
                <template #cell(ticket)="{item}">
                    <a class="fileName float" v-if="item.ticket"
                       :href="'../storage/quotings/ticket_cotizacion/'+item.ticket" target="_blank">
                        {{ item.ticket }}
                    </a>
                </template>
                <template #cell(fecha_de_carga)="{item}">
                    <span>{{ item.created_at }}</span>
                </template>
                <template #cell(tipo_ticket)="{item}">
                    <span v-if="item.type_ticket===1">Aprob. Cotizacíon</span>
                    <span v-if="item.type_ticket===2">Comisión Agente</span>
                    <span v-if="item.type_ticket===5">Comisión Promotor</span>
                </template>
                <template #cell(accion)="{item}">
                    <div class="dropdown">
                        <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fas fa-cogs"></i>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                        </div>
                    </div>
                </template>
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                    </div>
                </template>
            </b-table>
            <div class="row"></div>

        </div>

    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {ticketQuoterService} from "../../Services/TicketQuoter.service";
import {getFormData} from "../../Utils/getDataForm";
import {clientsService} from "../../Services/Clients.service";

export default {
    name: 'ticket',
    mixins: [myMixins],
    components: {
        DatePicker: () => import('vue2-datepicker'),
    },
    props: {
        quoter_id: {
            type: Number,
            required: true
        },
        approved_at: {
            type: Boolean,
            required: false
        },
        renew: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            end_date: '',
            start_date: '',
            payment_date: '',
            isBusy: false,
            modificar: false,
            type_ticket: 0,
            fields: [
                {key: 'ticket'},
                {key: 'fecha_de_carga'},
                {key: 'tipo_ticket'},
                {key: 'accion'}
            ],
            tickets: [],
            clients: [],
            tituloBtn: 'Agregar Documento',
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await ticketQuoterService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formTicketQuoter');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formTicketQuoter');
                resp = await ticketQuoterService.saveOne(formData, {
                    isForm: true,
                    onUploadProgress: this.onUploadProgress
                });
                //this.ticket.archivo = '';
                this.getAlert(resp.process, true);
                this.$emit('close-modal');
                //this.disableSubmitBtn(false);
                await this.index();

            }
            this.modificar = false;
        },
        async index() {

            if (this.renew) {
                this.clients = await clientsService.getMany({limit: 0});
            }
            //console.log('quoter_id', this.quoter_id, 'approved_at', this.approved_at);
            this.isBusy = true;
            //this.tickets = await ticketQuoterService.getOne(this.quoter_id);
            let resp = await ticketQuoterService.getOne(this.quoter_id);
            //NECESITO CHECAR QUE EL ADMIN PUEDA VER LAS FACTURAS QUE SE SUBIERON PARA EL PAGO DE COMISIONES
            //let resp = await invoiceQuotersService.getOne(this.quoter_id);
            //console.log(resp.length);
            if (resp[0] != null) {
                //console.log('si existe el documento');
                this.tickets = resp;
            } else {
                this.tickets = [];
            }

            //console.log('tickets = ', this.tickets);
            this.isBusy = false;
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
    },
    mounted() {
        this.index();
    }
}
</script>
